<qai-inner-wrap class="container">
  <div class="transcript-content">
    <!-- Header -->
    <div class="transcript-header">
      <span data-testId="callTranscript">{{'results.CALL_TRANSCRIPT' | transloco}}</span>
    </div>

    <!-- Messages -->
    @if (transcriptResponse) {
      <div class="transcript-container">
        <div
          data-testId="transcript"
          class="transcript"
          [innerHTML]="transformedTranscript"
        ></div>
      </div>
    } @else {
      <div class="no-transcript">
        {{'results.NO_TRANSCRIPT' | transloco}}
      </div>
    }
  </div>
</qai-inner-wrap>
